export const isDan = (profile) => {
    return profile === "Dan B.";
}